/** Full-screen pages that render without the app bar and footer (they carry their own way back home). */
const CHROMELESS_PATHS = ['/login', '/consent'];

export const isChromelessPath = (pathname: string): boolean => CHROMELESS_PATHS.includes(pathname);

/** Pages that close with their own footer, so the app footer would repeat it (the landing page). */
const OWN_FOOTER_PATHS = ['/'];

export const hasOwnFooter = (pathname: string): boolean => OWN_FOOTER_PATHS.includes(pathname);
